<template>
  <div>
    <!-- 个人意外伤害险协议 -->
    <h1>紫金财产保险股份有限公司</h1>
    <h1>人身意外伤害保险（2018版）条款</h1>
    <h6>注册编号：C00013732312018080213072</h6>
    <h2>总则</h2>
    <h3>第一条  本保险合同由保险条款、投保单、保险单、被保险人清单名册、声明、保险凭证以及批单等组成。凡涉及本保险合同的约定，均应采用书面形式。</h3>
    <h3>第二条  本保险合同的被保险人应为身体健康、能参与正常工作或劳动的自然人，可以作为被保险人参加本保险。</h3>
    <h3>第三条  本保险合同的投保人应为具有完全民事行为能力的被保险人本人、依法对被保险人有保险利益的其他人。</h3>
    <h3>第四条  本保险合同的受益人包括：</h3>
    <h4>（一）身故保险金受益人</h4>
    <p>订立本保险合同时，被保险人或投保人可指定一人或数人为身故保险金受益人。身故保险金受益人为数人时，应确定其受益顺序和受益份额；未确定受益份额的，各身故保险金受益人按照相等份额享有受益权。投保人指定受益人时须经被保险人同意。</p>
    <p>被保险人死亡后，有下列情形之一的，保险金作为被保险人的遗产，由保险人依照《中华人民共和国继承法》的规定履行给付保险金的义务：</p>
    <h5>（1）没有指定受益人，或者受益人指定不明无法确定的；</h5>
    <h5>（2）受益人先于被保险人死亡，没有其他受益人的；</h5>
    <h5> (3）受益人依法丧失受益权或者放弃受益权，没有其他受益人的。</h5>
    <p>受益人与被保险人在同一事件中死亡，且不能确定死亡先后顺序的，推定受益人死亡在先。</p>
    <p>被保险人或投保人可以变更身故保险金受益人，但需书面通知保险人，由保险人在本保险合同上批注。对因身故保险金受益人变更发生的法律纠纷，保险人不承担任何责任。</p>
    <p>投保人指定或变更身故保险金受益人的，应经被保险人同意。</p>
    <p>被保险人为无民事行为能力人或限制民事行为能力人的，可以由其监护人指定或变更身故保险金受益人。</p>
    <h4>（二）残疾保险金受益人</h4>
    <p>除另有约定外，本保险合同的残疾保险金的受益人为被保险人本人。</p>
    <h2>保险责任</h2>
    <h3>第五条  在本保险合同期间内，保险人承担下列保险责任：</h3>
    <h4>（一）意外身故保险责任：</h4>
    <p>被保险人在保险期间内遭受意外伤害事故，且自意外伤害事故发生之日起一百八十日内，因该意外事故导致身故，保险人按合同约定的意外身故保险金额给付意外身故保险金，保险责任终止。</p>
    <p>在给付意外身故保险金前，如该被保险人已领取过本条（二）规定的意外残疾保险金，保险人将从意外身故保险金中扣除已给付的意外残疾保险金。</p>
    <h4>（二）意外残疾保险责任：</h4>
    <p>在保险期间内，被保险人遭受意外伤害事故，并自事故发生之日起180日内造成《人身保险伤残评定标准及代码》（JR/T0083-2013）（由中国保险监督管理委员会发布，保监发〔2014〕6号）（以下简称《伤残评定标准及代码》）所列残疾程度之一者，保险人按该表所列比例乘以其保险金额给付意外残疾保险金。如自意外伤害发生之日起第180日时治疗仍未结束，按第180日的身体情况进行鉴定，并据此给付残疾保险金。</p>
    <p>1. 当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论；如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级，保险人以晋升后的伤残等级作为最终的评定结论。同一部位和性质的伤残，不应采用《伤残评定标准及代码》条文两条以上或者同一条文两次以上进行评定。</p>
    <p>2. 被保险人如在本次意外伤害事故之前已有伤残，保险人按合并后的伤残程度在《伤残评定标准及代码》中所对应的给付比例给付残疾保险金，但应扣除原有伤残程度在《伤残评定标准及代码》所对应的残疾保险金。</p>
    <p>在保险期间内，前述第（一）、（二）款下的保险金累计给付金额以保险单载明的意外伤害身故、残疾保险金额为限。</p>
    <h2>责任免除</h2>
    <h3>第六条  因下列情形之一，造成被保险人身故、残疾的，保险人不负给付保险金的责任：</h3>
    <h4>（一)投保人故意杀害、伤害被保险人；</h4>
    <h4>（二)被保险人故意犯罪或拒捕、自杀、故意自伤或者抗拒依法采取的刑事强制措施；</h4>
    <h4>（三)被保险人殴斗、醉酒，服用、吸食或注射毒品；</h4>
    <h4> (四)被保险人酒后驾驶、无有效驾驶证照驾驶，或驾驶无有效行驶证的机动车交通工具；</h4>
    <h4>（五)被保险人流产、分娩、疾病、药物过敏；</h4>
    <h4>（六)被保险人接受整容手术或其他内、外科手术；</h4>
    <h4>（七）被保险人未遵医嘱，私自服用、涂用、注射药物；</h4>
    <h4>（八）被保险人从事潜水、跳伞、攀岩运动、探险活动、武术比赛、摔跤比赛、特技表演、赛马、赛车等高风险运动；</h4>
    <h4>（九）被保险人患爱滋病（AIDS）或感染爱滋病毒（HIV呈阳性）期间；</h4>
    <h4>（十）战争、军事行动、暴乱或武装叛乱；</h4>
    <h4>（十一）核爆炸、核辐射或核污染；</h4>
    <h4>（十二）被保险人从事或参与恐怖主义活动、邪教组织活动；</h4>
    <h4>（十三）各种原因的猝死；</h4>
    <h4>（十四）中暑、高原环境或因素导致的死亡；</h4>
    <h4>（十五）保单载明的投保双方约定的其他情形。</h4>
    <p>发生上述情形，被保险人身故的，保险人对该被保险人保险责任终止，并按日计算退还该被保险人的未满期保费。</p>
    <h2>保险金额和保险费</h2>
    <h3>第七条  保险金额是保险人承担给付保险金责任的最高限额。保险金额由投保人、保险人双方约定，并在保险单中载明。投保人应该按照合同约定向保险人交纳保险费。</h3>
    <h2>保险期间</h2>
    <h3>第八条  本合同保险期间以保险人和投保人协商确定，以保险单载明的起讫时间为准。除另有约定外，保险期间最长不超过一年。</h3>
    <h2>保险人义务</h2>
    <h3>第九条  本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。</h3>
    <h3>第十条  保险人认为被保险人提供的有关索赔的证明和资料不完整的，应当及时一次性通知投保人、被保险人补充提供。</h3>
    <h3>第十一条  保险人收到被保险人的给付保险金的请求后，应当及时作出核定。情形复杂的，保险人应当在三十日内作出核定。</h3>
    <h3>对属于保险责任的，在与被保险人达成给付保险金的协议后十日内，履行赔偿保险金义务。保险合同对给付保险金的期限有约定的，保险人应当按照约定履行给付保险金的义务。</h3>
    <h3>保险人依照前款约定作出核定后，对不属于保险责任的，应当自作出核定之日起三日内向被保险人发出拒绝给付保险金通知书，并说明理由。</h3>
    <h3>第十二条  保险人自收到给付保险金的请求和有关证明、资料之日起六十日内，对其给付的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支付；保险人最终确定给付的数额后，应当支付相应的差额。 </h3>
    <h2>投保人、被保险人义务</h2>

    <h3>第十三条  除另有约定外，投保人应当在保险合同成立时交清保险费。 </h3>
    <h3>第十四条  订立保险合同，保险人就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。</h3>
    <p>投保人故意或者因重大过失未履行前款规定的义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本保险合同。</p>
    <p>投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担给付保险金责任，并不退还保险费。</p>
    <p>投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担给付保险金责任，但应当退还保险费。</p>
    <h3> 第十五条  被保险人变更职业或工种时，投保人或被保险人应在10日内以书面形式通知保险人。</h3>
    <p>被保险人所变更的职业或工种依照保险人职业分类在拒保范围内的，保险人在接到通知后有权解除本保险合同并按照接到通知之日退还原职业或工种所对应的未满期保费。被保险人所变更的职业或工种依照保险人职业分类仍可承保的或在拒保范围内但保险人认定可以继续承保的，保险人按照接到通知之日计算并退还原职业或工种所对应的未满期保费，投保人补交按照保险人接到通知之日计算的新职业或工种所对应的未满期保费。</p>
    <p>被保险人所变更的职业或工种，依照保险人职业分类其危险性增加，且未依本条约定通知保险人而发生保险事故的，保险人按其原交保险费比新职业或工种所对应的保险费率计算并给付保险金。被保险人所变更的职业或工种依照保险人职业分类在拒保范围内，保险人不承担给付保险金的责任。</p>
    <h3>第十六条  投保人住所或通讯地址变更时，应及时以书面形式通知保险人。投保人未通知的，保险人按本保险合同所载的最后住所或通讯地址发送的有关通知，均视为已发送给投保人。</h3>
    <h3>第十七条  在保险期间内，投保人因其人员变动，需增加、减少被保险人时，应以书面形式向保险人提出申请。保险人同意后出具批单，并在本保险合同中批注。</h3>
    <p>被保险人人数减少时，保险人在审核同意后，于收到申请之日的次日零时起，对减少的被保险人终止保险责任（如减少的被保险人属于已离职的，保险人对其所负的保险责任自其离职之日起终止），并按约定退还未满期保费，但减少的被保险人本人或其保险金申请人已领取过任何保险金的，保险人不退还未满期保费。</p>
    <h3>第十八条  投保人、被保险人或者保险金受益人知道保险事故发生后，应当及时通知保险人。故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担给付保险金责任，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。</h3>
    <p>上述约定，不包括因不可抗力而导致的迟延。</p>
    <h2>保险金申请与给付</h2>
    <h3>第十九条  保险金申请人向保险人申请给付保险金时，应提交以下材料。保险金申请人因特殊原因不能提供以下材料的，应提供其他合法有效的材料。保险金申请人未能提供有关材料，导致保险人无法核实该申请的真实性的，保险人对无法核实部分不承担给付保险金的责任。</h3>
    <h3>（一）身故保险金申请</h3>
    <h3>（1）保险金给付申请书；</h3>
    <h3>（2）投保人证明及保险单原件或其他保险凭证；</h3>
    <h3>（3）保险金申请人的身份证明；</h3>
    <h3>（4）公安部门出具的被保险人户籍注销证明、二级以上（含二级）或保险人认可的医疗机构出具的被保险人身故证明书。若被保险人为宣告死亡，保险金申请人应提供人民法院出具的宣告死亡证明文件；</h3>
    <h3>（5）保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料；</h3>
    <h3>（6）若保险金申请人委托他人申请的，还应提供授权委托书原件、委托人和受托人的身份证明等相关证明文件。</h3>
    <h3>除提交上述材料外，保险金申请人申请身故保险金时，为确定事故原因，保险人有权要求由司法鉴定机构对事故原因进行鉴定，如进行尸体检验等。</h3>
    <h3>（二）残疾保险金申请</h3>
    <h3>（1）保险金给付申请书；</h3>
    <h3>（2）投保人证明及保险单原件或其他保险凭证；</h3>
    <h3>（3）被保险人身份证明；</h3>
    <h3>（4）二级以上（含二级）或保险人认可的医疗机构或司法鉴定机构出具的残疾鉴定书；同时具备以下条件：</h3>
    <h5>①持有有效相关执业许可证；</h5>
    <h5>②具备相关法律法规要求的伤残鉴定资格；</h5>
    <h5>③遵守国家、省、市有关医疗服务管理的法律、法规、标准和规定。</h5>
    <h3>（5）保险金申请人所提供的其他与本项申请相关的材料；</h3>
    <h3>（6）若保险金申请人委托他人申请的，还应提供授权委托书原件、委托人和受托人的身份证明等相关证明文件。</h3>
    <h3>第二十条  保险金申请人向保险人请求给付保险金的诉讼时效期间为二年，自其知道或者应当知道保险事故发生之日起计算。</h3>
    <h2>争议处理和法律适用</h2>
    <h3>第二十一条  因履行本保险合同发生的争议，由当事人协商解决。协商不成的，提交保险单载明的仲裁机构仲裁；保险单未载明仲裁机构或者争议发生后未达成仲裁协议的，依法向人民法院起诉。</h3>
    <h3>第二十二条  与本保险合同有关的以及履行本保险合同产生的一切争议处理适用中华人民共和国法律（不包括港澳台地区法律）。</h3>
    <h2>其他事项</h2>
    <h3>第二十三条  在本保险合同成立后，投保人可以书面形式通知保险人解除合同，但保险人已根据本保险合同约定给付保险金的除外。</h3>
    <h3>投保人解除本保险合同时，应提供下列证明文件和资料：</h3>
    <h4>（1）保险合同解除申请书；</h4>
    <h4>（2）投保人证明及保险单原件或其他保险凭证；</h4>
    <h4>（3）投保人身份证明。</h4>
    <h4>投保人要求解除本保险合同，自保险人接到保险合同解除申请书之时起，本保险合同的效力终止。保险人收到上述证明文件和资料之日起30日内退还保险单的未满期保费。</h4>
    <h2>释义</h2>
    <h3>1、周岁：以法定身份证明文件中记载的出生日期为基础计算的实足年龄。</h3>
    <h3>2、保险人：指与投保人签订本保险合同的紫金财产保险股份有限公司。</h3>
    <h3>3、意外伤害：指以外来的、突发的、非本意的和非疾病的客观事件为直接且单独的原因致使身体受到的伤害。</h3>
    <h3>4、肢：指人体的四肢，即左上肢、右上肢、左下肢和右下肢。</h3>
    <h3>5、潜水：指以辅助呼吸器材在江、河、湖、海、水库、运河等水域进行的水下运动。</h3>
    <h3>6、攀岩运动：指攀登悬崖、楼宇外墙、人造悬崖、冰崖、冰山等运动。</h3>
    <h3>7、武术比赛：指两人或两人以上对抗性柔道、空手道、跆拳道、散打、拳击等各种拳术及各种使用器械的对抗性比赛。</h3>
    <h3>8、探险活动：指明知在某种特定的自然条件下有失去生命或使身体受到伤害的危险，而故意使自己置身其中的行为，如江河漂流、徒步穿越沙漠或人迹罕至的原始森林等活动。</h3>
    <h3>9、特技：指从事马术、杂技、驯兽等特殊技能。</h3>
    <h3>10、艾滋病：指后天性免疫力缺乏综合症。</h3>
    <h3>11、艾滋病病毒：指后天性免疫力缺乏综合症病毒。</h3>
    <h3>后天性免疫力缺乏综合症的定义应按世界卫生组织制定的定义为准，如在血液样本中发现后天性免疫力缺乏综合症病毒或其抗体，则可认定为感染艾滋病或艾滋病病毒。</h3>
    <h3>12、无有效驾驶证</h3>
    <h3>被保险人存在下列情形之一者：</h3>
    <h4>（1）无驾驶证或驾驶证有效期已届满；</h4>
    <h4>（2）驾驶的机动车与驾驶证载明的准驾车型不符；</h4>
    <h4>（3）实习期内驾驶公共汽车、营运客车或者载有爆炸物品、易燃易爆化学物品、剧毒或者放射性等危险物品的机动车，实习期内驾驶的机动车牵引挂车；</h4>
    <h4>（4）持未按规定审验的驾驶证，以及在暂扣、扣留、吊销、注销驾驶证期间驾驶机动车；</h4>
    <h4>（5）使用各种专用机械车、特种车的人员无国家有关部门核发的有效操作证，驾驶营业性客车的驾驶人无国家有关部门核发的有效资格证书；</h4>
    <h4>（6）依照法律法规或公安机关交通管理部门有关规定不允许驾驶机动车的其他情况下驾车。</h4>
    <h3>13、无有效行驶证</h3>
    <h3> 指下列情形之一：</h3>
    <h4>（1）机动车被依法注销登记的；</h4>
    <h4>（2）无公安机关交通管理部门核发的行驶证、号牌，或临时号牌或临时移动证的机动交通工具</h4>
    <h4>（3）未在规定检验期限内进行机动车安全技术检验或检验未通过的机动交通工具。未依法按时进行或通过机动车安全技术检验。</h4>
    <h3>14、未满期保费</h3>
    <h3>未满期保费=保险费×[1-(保险单已经过天数/保险期间天数)]。经过天数不足一天的按一天计算。</h3>
    <h3>15、保险金申请人：指受益人或被保险人的继承人或依法享有保险金请求权的其他自然人。</h3>
    <h3>16、不可抗力：指不能预见、不能避免并不能克服的客观情况。</h3>
    <h3>附录：短期费率表</h3>
    <div class="table">
      <div class="table-top">
        <p>保险期间(月)</p>
        <p>1</p>
        <p>2</p>
        <p>3</p>
        <p>4</p>
        <p>5</p>
        <p>6</p>
        <p>7</p>
        <p>8</p>
        <p>9</p>
        <p>10</p>
        <p>11</p>
        <p>12</p>
      </div>
      <div class="table-button">
        <p>增长比例(%)</p>
        <p>10</p>
        <p>20</p>
        <p>30</p>
        <p>40</p>
        <p>50</p>
        <p>60</p>
        <p>70</p>
        <p>80</p>
        <p>85</p>
        <p>90</p>
        <p>95</p>
        <p>100</p>
      </div>
    </div>
    <p>（注：保险期间月数不足一月的按一月计算）。</p>
  </div>
</template>

<script>
export default {
  activated(){
      this.$store.commit('setShow',false)
  }
}
</script>

<style lang="scss" scoped>
  @import "./InsuranceClauses.scss"
</style>



// WEBPACK FOOTER //
// src/pages/car/InsuranceClauses/index.vue